import React, { useEffect, useState } from "react";
import api from "../../services/api"; // Import Axios instance
import BlogCard from "../../components/BlogCard/BlogCard";
import "./BlogListing.css";

const BlogListing = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await api.get("/blogs"); // Fetch blogs from API
      setBlogs(response.data.blogs);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (loading) {
      // Scroll window to top when loading starts
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [loading]);

  useEffect(() => {
    fetchBlogs();
  }, []);
  if (loading) {
    return (
      <div className="main">
        <div className="up">
          <div className="loaders">
            {[...Array(10)].map((_, i) => (
              <div key={i} className="loader"></div>
            ))}
          </div>
          <div className="loadersB">
            {[...Array(9)].map((_, i) => (
              <div key={i} className="loaderA">
                <div className={`ball${i}`}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-listing">
      <div className="blog-overlayer">
        <h2>Latest From Blog</h2>
        {loading ? (
          <p>Loading blogs...</p>
        ) : (
          <div className="container">
            <div className="blog-cards-container row">
              {blogs.map((blog) => (
                <div className=" col-md-6 col-lg-4" key={blog.id}>
                  <BlogCard blog={blog} role={user?.role || ""} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogListing;
